import React from 'react';
import { IntlProvider } from "react-intl";
import { BreadcrumbsProvider } from 'react-breadcrumbs-dynamic';
import { BrowserRouter, Route } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary.jsx";
import CeLogin from "./components/CeLogin/CeLogin";
import CePrivacyStatement from "./components/CePrivacyStatement/CePrivacyStatement";
import CeTop from "./components/CeTop/CeTop";
import CeCreateAccount from "./components/CeCreateAccount/CeCreateAccount";
import CeAddCustomer from "./components/CeAddCustomer/CeAddCustomer";
import CeOperatorTop from "./components/CeOperatorTop/TopOperator";
import EditCustomerDetails from './components/EditCustomerDetails/EditCustomerDetails.jsx';
import Requests from "./components/Requests/Requests";
import CEFullScreenOutputPaperGraph from "./components/CeOperatorTop/FullScreen/FullScreenOutputPaperGraph";
import CEFullScreenAvailabilityResultsGraph from "./components/CeOperatorTop/FullScreen/FullScreenAvailabilityResultsGraph";
import CEFullScreenInterruptionTable from "./components/CeOperatorTop/FullScreen/FullScreenInterruptionTable";
import { setLocalStorageRevision } from './Common/revisionCheck';
import {updateLanguage ,getMessage} from "./Common/ChangLanguage";
import Suggestion from "./components/CeSuggestion/Suggestion";



class App extends React.Component {

    constructor(prop) {
        super(prop);

        let lang = !localStorage.getItem('lang') ? 'en' : localStorage.getItem('lang');
        this.updateLang(lang);
        let screen = !localStorage.getItem('screen') ? 'manager' : localStorage.getItem('screen');
        this.updateScreen(screen);
        this.state = {
            lang: lang,
            message: getMessage(lang),
            curScreenWidth: 0,
        }
        this.updateLang = this.updateLang.bind(this);
        this.updateScreen = this.updateScreen.bind(this);
        this.redirectScreen = this.redirectScreen.bind(this);
    }

    updateLang = (lang) => {
        updateLanguage(this,lang)
    };

    updateScreen = (screen) => {
        localStorage.setItem('screen', screen);
    };

    redirectScreen = (props) => {
        // エラートースト表示
        props.openSnackbar(props.intl.formatMessage({ id: "http_get_error" }, { status: 999 }));
        // ログイン画面に遷移
        window.location.href = "/";
    };

    componentDidMount(){
        this.setState({ curScreenWidth: document.documentElement.clientWidth });
        window.onresize = () => {
            this.setState({ curScreenWidth: document.documentElement.clientWidth });
        };
        setTimeout(() => {
            // リビジョンアップ完了フラグをFalseにセット
            setLocalStorageRevision({ RELOADING_FLG: false});
        }, 3000);
    };

    render() {
        return (
            <BreadcrumbsProvider>
                <IntlProvider
                    locale={this.state.lang}
                    messages={this.state.message}>
                    <ErrorBoundary redirectScreen={this.redirectScreen}>
                        <div className="App">
                            <BrowserRouter>
                                <Route exact path="/">
                                    <CeLogin updateLang={this.updateLang} updateScreen={this.updateScreen} curScreenWidth={this.state.curScreenWidth}/>
                                </Route>
                                <div className="App-header">
                                    <Route exact path="/ce/privacyStatement">
                                        <CePrivacyStatement />
                                    </Route>
                                    <Route exact path="/ce/top">
                                        <CeTop />
                                    </Route>
                                    <Route exact path="/ce/createAccount">
                                        <CeCreateAccount />
                                    </Route>
                                    <Route exact path="/ce/top/addCustomer">
                                        <CeAddCustomer />
                                    </Route>
                                    <Route exact path="/ce/top/editCustomer">
                                        <EditCustomerDetails />
                                    </Route>
                                    <Route exact path="/ce/top/requests">
                                        <Requests />
                                    </Route>
                                    <Route exact path="/ce/operatorTop">
                                        <CeOperatorTop />
                                    </Route>
                                    <Route exact path="/ce/operatorTop/outputpapergraph">
                                        <CEFullScreenOutputPaperGraph />
                                    </Route>
                                    <Route exact path="/ce/operatorTop/availabilityresultsgraph">
                                        <CEFullScreenAvailabilityResultsGraph />
                                    </Route>
                                    <Route exact path="/ce/operatorTop/interruptionTable">
                                        <CEFullScreenInterruptionTable />
                                    </Route>
                                    <Route exact path="/ce/top/editCustomer/editSuggestion">
                                        <Suggestion />
                                    </Route>
                                </div>
                            </BrowserRouter>
                        </div>
                    </ErrorBoundary>
                </IntlProvider>
            </BreadcrumbsProvider>
        );
    }
}

export default App;